const STORAGE = window.localStorage

const getItemFromStorage = (key, defaultValue) => {
  try {
    const parsedItem = JSON.parse(STORAGE.getItem(key))
    return parsedItem
  } catch (e) {
    STORAGE.removeItem(key)
    console.log(e.message)
    return defaultValue
  }
}

const setItemToStorage = (key, item) => {
  STORAGE.setItem(key, JSON.stringify(item))
}

const removeItemToStorage = key => {
  STORAGE.removeItem(key)
}

export { getItemFromStorage, setItemToStorage, removeItemToStorage }
